import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import lottie from "lottie-web";
import animationData from "../../lottie/reportage-lottie.json";

gsap.registerPlugin(ScrollTrigger);

function pinSection() {
    const container = document.getElementById("lottieAnim");
    if (!container) return;

    const anim = lottie.loadAnimation({
        container: container,
        renderer: "svg",
        loop: false,
        autoplay: false,
        animationData: animationData,
    });

    ScrollTrigger.create({
        trigger: container,
        start: "top 80%",
        once: true,
        onEnter: () => {
            anim.play();
        },
    });
}

export { pinSection };
